import React, { useState, useEffect } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"; // , {textFilter, selectFilter, dateFilter,}
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"; // , { Search, CSVExport,}
import cellEditFactory from "react-bootstrap-table2-editor";
// import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { toast } from "react-toastify";
import { Row, Col, Form, Button, FormControl } from "react-bootstrap";
// import { CSVLink } from "react-csv";

// Import Service
import factoryService from "../../services/factory.service";
import authService from "../../services/auth.service";
// import farmerService from "../../services/farmer.service";

//Import Loading
// import Spinner from "react-bootstrap/Spinner";
// import { confirmAlert } from "react-confirm-alert";
import LoadingAlert from "../../components/LoadingAlert";

// Import Modal
// import ModalViewDetail from "./modalViewMembers";
// import ModalAddFactory from "./modalAddFactory";
// import ModalEditFactory from "./modalEditFactory";
// import ModalCheckMember from "./modalCheckMember";
// import MemberForm from "./formMember";

//Import tooltip
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";

import "./factory.css";

const Factorylist = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [factoryFilter, setFactoryFilter] = useState([]);
  const [search, setSearch] = useState({});

  const user = authService.getCurrentUser();
  const { ExportCSVButton } = CSVExport;
  useEffect(() => {
    // getData();
    // getFactory();
    getFactoryFilter();
    setLoading(false);
  }, []);

  const getData = () => {
    setLoading(true);
    factoryService
      .getContractList(search)
      .then((response) => {
        console.log(response);
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getFactoryFilter = () => {
    factoryService.getFactorylist().then((response) => {
      setFactoryFilter(response.data.data);
      // console.log(props);
    });
  };

  const optionPeriod = [
    { value: "2563-2564", label: "2563-2564" },
    { value: "2564-2565", label: "2564-2565" },
    { value: "2565-2566", label: "2565-2566" },
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };

  const setField = (field, value) => {
    setSearch({
      ...search,
      [field.name]: value,
    });
  };

  const showCSVButton = (prop) => {
    if (user.user.member_type === 5 || user.user.member_type === 8) {
      return (
        // <CSVLink
        //   data={data}
        //   headers={[...headers.filter((a) => a.csvExport !== false)]}
        //   filename={"คู่สัญญา.csv"}
        //   className="btn btn-success"
        //   target="_blank"
        //   style={{
        //     padding: ".375rem .75rem",
        //     fontSize: "1rem",
        //     float: "right",
        //   }}
        // >
        //   <i className="bi bi-download"></i>
        // </CSVLink>
        <ExportCSVButton
          {...prop.csvProps}
          style={{
            padding: ".375rem .75rem",
            fontSize: "1rem",
            float: "right",
          }}
        >
          <i className="bi bi-download"></i>
        </ExportCSVButton>
      );
    } else if (user.user.member_type === 6) {
      return (
        <div>
          {/* <CSVLink
            data={data}
            headers={[...headers.filter((a) => a.csvExport !== false)]}
            filename={"คู่สัญญา.csv"}
            className="btn btn-success"
            target="_blank"
            style={{
              padding: ".375rem .75rem",
              fontSize: "1rem",
              float: "right",
            }}
          >
            <i className="bi bi-download"></i>
          </CSVLink> */}
          <ExportCSVButton
            {...prop.csvProps}
            style={{
              padding: ".375rem .75rem",
              fontSize: "1rem",
              float: "right",
            }}
          >
            <i className="bi bi-download"></i>
          </ExportCSVButton>
        </div>
      );
    }
  };

  const changeStatus = (body) => {
    console.log(body);
    factoryService
      .activateFactory(body)
      .then((res) => {
        if (res.data.success) {
          // toast.success(res.data.message);
          toast.success("แก้ไขเรียบร้อย !!", {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err));
  };

  const dateFormatter = (cell) => {
    const getdate = new Date(cell);
    return (
      <p>
        {getdate.toLocaleString("th-TH", {
          year: "2-digit",
          month: "short",
          day: "numeric",
        })}
      </p>
    );
  };

  const headerSortingStyle = {
    backgroundColor: "#D4EFDF",
    verticalAlign: "center",
  };

  const columns = [
    {
      text: "contract_id",
      dataField: "contract_id",
      sort: true,
      hidden: true,
      csvExport: false,
    },
    {
      text: "ปีที่ส่ง",
      dataField: "contractseason",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
    },
    {
      text: "เลขสัญญา",
      dataField: "contractno",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "15%" };
      },
      headerSortingStyle,
      filter: textFilter({
        placeholder: "เลขสัญญา",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "ชาวไร่",
      dataField: "farmername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "20%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "left",
      },
      filter: textFilter({
        placeholder: "ชื่อ-สกุล",
        style: { fontSize: "98%", width: "100%" },
      }),
    },
    {
      text: "โรงงาน",
      dataField: "factoryname",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "25%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "left",
      },
    },
    {
      text: "ยอดจด (ตัน)",
      dataField: "contractcane",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
    },
    {
      text: "ส่งจริง (ตัน)",
      dataField: "deliveredcane",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
      style: {
        textAlign: "right",
      },
    },
    {
      text: "เริ่มสัญญา",
      formatter: dateFormatter,
      dataField: "contractdate",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { verticalAlign: "middle", width: "10%" };
      },
      headerSortingStyle,
    },
    // {
    //   text: "แก้ไข",
    //   dataField: "edit",
    //   isDummyField: true,
    //   editable: false,
    //   formatter: actionsViewFormatter,
    //   headerStyle: () => {
    //     return { verticalAlign: "middle", width: "10%" };
    //   },
    //   headerSortingStyle,
    // },
  ];

  // const headers = [
  //   ...columns.map((a) => {
  //     return { label: a.text, key: a.dataField, csvExport: a.csvExport };
  //   }),
  // ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // if (loading)
  //   return (
  //     <>
  //       <p>
  //         <Spinner animation="border" variant="success" />
  //         <span>&nbsp;กรุณารอ เนื่องจากข้อมูลมีปริมาณมาก</span>
  //       </p>
  //     </>
  //   );
  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      <ToolkitProvider
        bootstrap4
        keyField="factoryId"
        data={data}
        columns={columns}
        search
        exportCSV={{
          fileName: "ข้อมูลคู่สัญญา.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <Row>
                <Col md={11}>
                  <Form className="d-flex">
                    <Col md={1}>ค้นหา : </Col>
                    <Col md={2}>
                      <Form.Select
                        size="sm"
                        name="periodSearch"
                        value={search.periodSearch}
                        // onChange={handleSearchDopaChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      >
                        <option value="">ปีที่ส่ง</option>
                        {optionPeriod.map((o) => (
                          <option key={o.value} value={o.value}>
                            {o.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        size="sm"
                        name="factorySearch"
                        value={search.factorySearch}
                        // onChange={handleSearchStatusChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      >
                        <option value="">-- โรงงาน --</option>
                        {factoryFilter.map((o) => (
                          <option key={o.index} value={o.factoryId}>
                            {o.factoryFullName}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={4}>
                      <FormControl
                        size="sm"
                        name="textSearch"
                        value={search.textSearch}
                        type="search"
                        placeholder="เลขสัญญา, รหัส / ชื่อโรงงาน, ชาวไร่"
                        aria-label="Search"
                        // onChange={handleSearchChange}
                        onChange={(e) => setField(e.target, e.target.value)}
                      />
                    </Col>
                    <Col md={2}>
                      <Button
                        className="btn btn-info"
                        onClick={handleSearch}
                        style={{
                          margin: "0 0 0 0.5rem",
                          padding: ".375rem .75rem",
                          fontSize: ".75rem",
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </Button>
                    </Col>
                  </Form>
                </Col>
                <Col md={1}>{showCSVButton(prop)}</Col>
              </Row>
            </div>
            <hr />
            <BootstrapTable
              pagination={pagination}
              keyField="contract_id"
              data={data}
              columns={columns}
              loading={true}
              filter={filterFactory()}
              // headerClasses="header-class"
              {...prop.baseProps}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  changeStatus({
                    factoryid: row.factoryId,
                    factorystatus: newValue,
                  });
                  console.log(oldValue);
                  console.log(newValue);
                  console.log(row);
                  console.log(column);
                  console.log("After Saving Cell!! ");
                },
              })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default Factorylist;
